/**
 * @typedef {import('./iso6393.js').Type} Type
 * @typedef {import('./iso6393.js').Scope} Scope
 * @typedef {import('./iso6393.js').Language} Language
 */

export {iso6393} from './iso6393.js'
export {iso6393To1} from './iso6393-to-1.js'
export {iso6393To2B} from './iso6393-to-2b.js'
export {iso6393To2T} from './iso6393-to-2t.js'
